module.exports = __webpack_public_path__ + "static/media/andrew-moroz-resume-p2.bbb4e423.jpg";